import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { layers } from '../data/lessons';
import './Topics.css';

const allTopics = layers[0].lessons;

const categories = [
  { id: 'basics', label: 'Money basics' },
  { id: 'investing', label: 'Investing' },
  { id: 'protection', label: 'Protection' },
];

const topicMeta = {
  1: { category: 'basics' },
  2: { category: 'basics' },
  3: { category: 'basics' },
  4: { category: 'investing' },
  5: { category: 'protection' },
  6: { category: 'basics' },
};

export default function Topics() {
  const [activeCategory, setActiveCategory] = useState(null);

  const filteredTopics = activeCategory
    ? allTopics.filter(t => topicMeta[t.id]?.category === activeCategory)
    : allTopics;

  return (
    <div className="topics-page">
      <Helmet>
        <title>Topics — DhanAcademy</title>
        <meta name="description" content="Deep dives into money, investing, and protection — explained clearly with real Indian examples." />
      </Helmet>

      <section className="topics-hero">
        <div className="topics-hero-inner">
          <span className="topics-pill">TOPICS</span>
          <h1 className="topics-hero-title">Deep dives, explained clearly.</h1>
          <p className="topics-hero-sub">
            Each topic is a complete guide with real Indian examples, a key takeaway, and a short quiz to test yourself.
          </p>
        </div>
      </section>

      <div className="topics-body">
        <div className="topics-inner">

          <div className="topics-filter-row">
            <button
              className={`topics-filter-pill ${!activeCategory ? 'topics-filter-pill-active' : ''}`}
              onClick={() => setActiveCategory(null)}
            >
              All
            </button>
            {categories.map(c => (
              <button
                key={c.id}
                className={`topics-filter-pill ${activeCategory === c.id ? 'topics-filter-pill-active' : ''}`}
                onClick={() => setActiveCategory(activeCategory === c.id ? null : c.id)}
              >
                {c.label}
              </button>
            ))}
          </div>

          <div className="topics-count">
            {filteredTopics.length} {filteredTopics.length === 1 ? 'topic' : 'topics'}
          </div>

          <div className="topics-grid">
            {filteredTopics.map(topic => (
              <Link key={topic.id} to={`/topic/${topic.id}`} className="topics-card">
                <h3 className="topics-card-title">{topic.title}</h3>
                <p className="topics-card-desc">{topic.description}</p>
                <div className="topics-card-footer">
                  <span className="topics-card-duration">{topic.duration} min read</span>
                  <span className="topics-card-link">Read →</span>
                </div>
              </Link>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
}
